import React from 'react';
import SbEditable from 'storyblok-react';
import { BlokComponent } from '../../../types/blok.model';

interface FaqEntryProps {
  question: string;
  answer: string;
}

const FaqItemBlok: BlokComponent<FaqEntryProps> = ({ blok }) => {
  return (
    <SbEditable content={blok}>
      <div className="faq-entry">
        <h3>{blok.question}</h3>
        <p>{blok.answer}</p>
      </div>
    </SbEditable>
  );
};

export default FaqItemBlok;
